import {
  HttpMethod,
  SubscriptionActiveAction,
  UpgradeSubscriptionPlanRequest,
  UpgradeSubscriptionPlanResponse,
} from '@aibees/shared/definition';
import { useBaseMutation } from '@aibees/shared/http/hooks';
import { useCustomerEndpoint } from '@aibees/shared/workspace';

export function useUpgradePlanMutationApi(action: SubscriptionActiveAction) {
  const endpoint = useCustomerEndpoint('subscription');

  return useBaseMutation<
    UpgradeSubscriptionPlanRequest,
    UpgradeSubscriptionPlanResponse
  >({
    url: endpoint,
    method: HttpMethod.post,
    params: { action },
  });
}
